import { render } from "./FTable.vue?vue&type=template&id=2db35a86"
import script from "./FTable.vue?vue&type=script&lang=js"
export * from "./FTable.vue?vue&type=script&lang=js"

import "./FTable.vue?vue&type=style&index=0&id=2db35a86&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__